module.exports = __webpack_public_path__ + "static/media/export.4ec74e24.svg";